export default __webpack_public_path__ + "assets/images/safe-secure-fb8b7ae992e3cb348a821b6d1683699c.svg";